import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import find from 'lodash/find';
import isNil from 'lodash/isNil';

import { Dropdown } from './Dropdown';
import { mergeClassNames, prefixPrevProps } from '../../utils/utilsGlobal';
import originalStyles from './EditableSelect.scss';


export class EditableSelect extends Component {

  dropdown = React.createRef();
  input = React.createRef();
  fakeInput = React.createRef();

  state = {
    normalizedOptions: [],
    inputValue: '',
    selectedOptionValue: null,
    isSelectFocused: false,
  };

  componentDidMount(){
    const { options, defaultValue } = this.props;
    const inputValue = !isNil(defaultValue) ? defaultValue : '';

    this.setSerializedOptions(options);
    this.setState({ inputValue }, this.syncInputWidth);
  }

  componentDidUpdate(prevProps){
    const { options, value } = this.props;
    const { prevOptions, prevValue } = prefixPrevProps(prevProps);

    if (options !== prevOptions) {
      this.setSerializedOptions(options);
    }
    if (value !== prevValue) {
      const selectedOption = find(this.state.normalizedOptions, { value });
      if (selectedOption) {
        this.setState({ selectedOptionValue: selectedOption.value });
      }
    }
  }

  setSerializedOptions = (options) => {
    const { defaultValue, value, getValueSuffix = () => '' } = this.props;
    const { selectedOptionValue } = this.state;

    if (!options || !options.length) {
      return [];
    }

    let normalizedOptions = options;

    if (typeof options[0] !== 'object') {
      normalizedOptions = options.map(value => {
        return {
          title: value + ' ' + getValueSuffix(value),
          value: value,
        };
      });
    }

    this.setState({ normalizedOptions });

    if (!selectedOptionValue) {
      const selectedOption = find(normalizedOptions, { value: value || defaultValue }) || normalizedOptions[0];
      if (selectedOption) {
        this.setState({ selectedOptionValue: selectedOption.value });
      }
    }
  };

  isValidValue = (value) => {
    const { type, min = 0, max = Infinity } = this.props;
    if (type === 'number') {
      const isNumber = /^[0-9]+$/.test(value) || !value;
      const isInRange = +value >= min && +value <= max;
      return Boolean(isNumber && isInRange);
    }
    return true;
  };

  onInputBlur = (e) => {
    const { defaultValue, value } = this.props;
    const inputValue = e.target.value;
    if (!inputValue.trim() && isNil(value)) {
      this.setInputValue(defaultValue);
    }
  };

  setInputValue = (inputValue) => {
    const { onChange, value, getValueSuffix = () => '' } = this.props;

    if (isNil(value) && this.isValidValue(inputValue)) {
      const normalizedInputValue = this.props.type === 'number' ? +inputValue : inputValue;
      const selectedOption = this.getOptionByValue(normalizedInputValue);

      if (selectedOption) {
        onChange(selectedOption);
      }
      else {
        onChange({
          title: normalizedInputValue + ' ' + getValueSuffix(normalizedInputValue),
          value: normalizedInputValue,
        })
      }
      this.setState({
        selectedOptionValue: selectedOption?.value || null,
        inputValue,
      }, this.syncInputWidth);
    }
  };

  onDropdownChange = (selectedOption) => {
    const { onChange, value } = this.props;
    onChange(selectedOption);

    if (isNil(value)) {
      this.setState({
        selectedOptionValue: selectedOption.value,
        inputValue: selectedOption.value,
      }, this.syncInputWidth);
    }
  };

  syncInputWidth = () => {
    const { editable } = this.props;
    if (editable) {
      setTimeout(() => {
        this.input.current.style.width = (this.fakeInput.current.offsetWidth + 1) + 'px';
      });
    }
  };

  getOptionByValue = (optionValue) => {
    const { normalizedOptions } = this.state;
    return find(normalizedOptions, { value: optionValue });
  };

  render(){
    const {
      className,
      placeholder,
      editable,
      defaultValue,
      overrideClassNames,
      getValueSuffix = () => '',
    } = this.props;

    const {
      normalizedOptions,
      selectedOptionValue,
      inputValue,
    } = this.state;

    if (!editable && (selectedOptionValue === null || selectedOptionValue === undefined)) {
      return null;
    }

    const selectedOption = this.getOptionByValue(selectedOptionValue);
    const styles = mergeClassNames(originalStyles, overrideClassNames);

    return (
      <Dropdown
        overrideClassNames={{
          container: cn(className, styles.container, overrideClassNames?.container),
          ...overrideClassNames
        }}
        ref={this.dropdown}
        defaultValue={defaultValue}
        onChange={this.onDropdownChange}
        items={normalizedOptions}>

        <div className={styles.value}>
          {editable && (
            <Fragment>
              <span className={styles.fakeInput} ref={this.fakeInput}>{inputValue}</span>
              <input className={styles.input}
                type="text"
                ref={this.input}
                value={inputValue}
                placeholder={placeholder}
                onBlur={this.onInputBlur}
                onChange={(e) => { this.setInputValue(e.target.value) }}/>

              {Boolean(getValueSuffix(inputValue)) && (
                <span className={styles.valueText}>{getValueSuffix(inputValue)}</span>
              )}
            </Fragment>
          )}
          {!editable && (
            <span className={styles.selectedValue}>
              {selectedOption.selectedTitle || selectedOption.title}
            </span>
          )}
          {Boolean(normalizedOptions.length) && (
            <i className={cn(styles.valueArrow, 'icon-chevron-down')}/>
          )}
        </div>

      </Dropdown>
    );
  }
}
